import { Component, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { Destroyable, untilDestroy } from '@tokeet-frontend/tv3-platform'
import {
  selectUnreadCount,
  selectUnreadCountLoaded,
  selectUnreadCountLoading,
} from '@tv3/store/message/message.selectors'
import { LoadUnreadCount } from '@tv3/store/message/message.actions'
import { combineLatest } from 'rxjs'
import { take } from 'rxjs/operators'

@Component({
  selector: 'app-messages-icon',
  templateUrl: './messages-icon.component.html',
  styleUrls: ['./messages-icon.component.scss'],
})
export class MessagesIconComponent extends Destroyable implements OnInit {
  unreadCount = 0
  constructor(private store: Store<fromRoot.State>) {
    super()
  }

  ngOnInit() {
    // Only load unread count if not already loaded or loading
    combineLatest([this.store.pipe(select(selectUnreadCountLoaded)), this.store.pipe(select(selectUnreadCountLoading))])
      .pipe(take(1))
      .subscribe(([isLoaded, isLoading]) => {
        if (!isLoaded && !isLoading) {
          this.store.dispatch(LoadUnreadCount())
        }
      })

    this.store.pipe(select(selectUnreadCount), untilDestroy(this)).subscribe((count) => {
      this.unreadCount = count
    })
  }
}
